/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        $('.open-popin').click(function(){
          $('.popin#'.$(this).data('popin')).addClass('active');
        });
        $('.popin *[data-action="close"]').click(function(){
          $(this).parents('.popin').removeClass('active');
        });

        // COMING SOON POPIN
        // var lastVisit = localStorage.getItem('forestier-visit');
        // var now = Date.now();
        // var needReminder = true;
        // if (lastVisit) {
        //   var daysSinceLastVisit = Math.abs(lastVisit - now) / (1000 * 60 * 60 * 24);
        //   if (daysSinceLastVisit < 7) {
        //     needReminder = false;
        //   }
        // }
        // if (needReminder) {
        //   // Open popin
        //   $('.popin#coming-soon').addClass('active');
        //   // Save visit timestamp
        //   localStorage.setItem('forestier-visit', now);
        // }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        // plyr.setup();
        var yt_launcher = $('.yt-launcher');

        if (yt_launcher.length) {
          $(document).on('click', '.yt-launcher', function(event) {
            event.preventDefault();

            var yt_overlay = $(this).find('.video-overlay');
            var yt_iframe = $(this).find('.video-overlay-youtube');
            var yt_img = $(this).find('.yt-launcher-img');

            var dataSrc = yt_iframe.data('src');

            var sourceUrl = dataSrc + '?rel=0&controls=1&showinfo=0&autoplay=1&mute=1';

            yt_iframe.attr('src', sourceUrl);
            yt_overlay.hide();
            yt_img.hide();
            yt_iframe.addClass('show');

          });
        };

        $('.video-link').off('click').on('click', function(e) {
          e.preventDefault();

          var $parent = $(this).closest('.window-orthodontie');
          var $container = $parent.find('.youtube--oaten');
          var $playerElement = $container.find('.js-player');

          $parent.show().css('display', 'block');
          $container.addClass('active');
          $('body').addClass('noscroll');

          setTimeout(function() {
            if (typeof plyr !== 'undefined') {
              plyr.setup($playerElement[0], {
                youtube: {
                  origin: window.location.origin,
                  noCookie: true,
                  autoplay: 1
                }
              });
            }
          }, 500);
        });

        $('.pop-out-close').on('click', function() {
          var $container = $(this).closest('.youtube--oaten');
          $container.removeClass('active');
          $('body').removeClass('noscroll');

          var playerInstance = $container.find('.js-player')[0].plyr;
          if (playerInstance) {
            playerInstance.pause();
          }
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // OATEN
  jQuery(document).ready(function ($) {

    // Detect iOS
    var isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    // Toggle mobile
    $(document).on('click', '.window > label', function (e) {

      // iOS : do NOT block native behavior
      if (!isiOS) {
        e.preventDefault();
        e.stopPropagation();
      }

      if (window.innerWidth > 640) {
        return;
      }

      var $label     = $(this);
      var $window    = $label.closest('.window');
      var $container = $window.find('.window-container');
      var $post      = $window.find('.post');

      var postHeight = $post.outerHeight(true);
      var isOpen     = $window.hasClass('open');

      if (!isOpen) {
        // Open
        $container.css({
          height: postHeight,
          marginBottom: 40
        });
        $label.addClass('active');
        $label.find('span').css({ transform: 'rotate(180deg)' });
        $window.addClass('open');

      } else {
        // Close
        $container.css({
          height: 0,
          marginBottom: 0
        });
        $label.removeClass('active');
        $label.find('span').css({ transform: 'rotate(360deg)' });
        $window.removeClass('open');
      }

    });

    // Reset resize desktop
    $(window).on('resize', function () {
      if (window.innerWidth > 640) {
        $('.window').removeClass('open');
        $('.window-container').css({
          height: '',
          marginBottom: ''
        });
        $('.window > label')
          .removeClass('active')
          .find('span')
          .css({ transform: '' });
      }
    });
  });

  $('.slider').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    autoPlay: 4500,
    pauseAutoPlayOnHover: false,
    imagesLoaded: true
  });

  $('.slider-emilie-oaten').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    autoPlay: 4500,
    pauseAutoPlayOnHover: false,
    imagesLoaded: true
  });

    document.querySelector("#menu-mobile").addEventListener("click", function(){
      document.querySelector(".full-menu").classList.toggle("active");
      document.querySelector("body").classList.toggle("noscroll");
    });

    var body = $('body'),
    popOut = $('#pop-out-container');

    $('.mt,.copy').click(function(e){
      e.preventDefault();
      popOut.addClass('active');
      body.addClass('noscroll');
    });

    $('.copy').click(function() {
        $( "#pop-out-container" ).empty();
        $.ajax({
            url: document.AJAXURL,
            data: {
                action: 'credits'
            },
            success: function(data) {
                $('#pop-out-container').append(data);
            },
            error: function(MLHttpRequest, textStatus, errorThrown){
                alert(errorThrown);
            }
        });
    });

    $('.mt').click(function() {
            $( "#pop-out-container" ).empty();
            $.ajax({
                url: document.AJAXURL,
                data: {
                    action: 'mentions_legales'
                },
                success: function(data) {
                    $('#pop-out-container').append(data);
                },
                error: function(MLHttpRequest, textStatus, errorThrown){
                    alert(errorThrown);
                }
            });
        });

        $('.orthodontie-video-category').click(function() {

            var selected_cat = $(this).attr('data-cat');
            var scrollCat = $(this);

            if ( $(this).hasClass('active') ) {
                $('.orthodontie-video-category').removeClass('active');
                $( ".window-orthodontie" ).fadeOut( "slow", function() {});
                $('html, body').animate({
                    scrollTop: scrollCat.offset().top - $('header').height() - 40
                }, 600);

            } else {
                $('.orthodontie-video-category').removeClass('active');
                $(this).addClass('active');

                $( ".window-orthodontie" ).fadeOut( 0, function() {});
                $( ".single-"+selected_cat ).fadeIn( "slow", function() {
                });
                $('html, body').animate({
                    scrollTop: scrollCat.offset().top - $('header').height() - 40
                }, 600);
            }
        });

})(jQuery); // Fully reference jQuery after this point.
